import React from "react";
import { Nav, Navbar } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import {
    BrowserRouter as Router, Route, Switch, useRouteMatch
} from "react-router-dom";

import Redir from "../redirect";
import ExportCSV from "./admin/export_csv_seasons";
import Players from "./admin/players";
import AdminSeasons from "./admin/seasons";

import PennantOverview from "./pennantOverview";
import Seasons from "./user/seasons";


import './anuPennant.css';


export default function ANUPennant(props) {
    let match = useRouteMatch();
    let isAdmin = props.isAdmin

    return (
        <div>
            <Redir></Redir>
            <Router>
                <div className='grid-wrapper'>
                    <Navbar
                        className="sidebar"
                        variant="dark"
                    >
                        <Nav className="sub-sidebar" >
                            {/* <LinkContainer to={`${match.url}`}>
                                <Nav.Link >ANU Pennant Overview</Nav.Link>
                            </LinkContainer> */}
                            <div>
                                <LinkContainer to={`${match.url}/seasons`}>
                                    <Nav.Link>Seasons</Nav.Link>
                                </LinkContainer>
                            </div>
                        </Nav>

                        <Nav className="sub-sidebar">
                            {isAdmin ?
                                <div>
                                    {/* <Nav> */}
                                    <span style={{ "color": "white", "fontWeight": "bold" }}>Admin</span>
                                    <LinkContainer to={`${match.url}/admin/players`}>
                                        <Nav.Link>Players</Nav.Link>
                                    </LinkContainer>
                                    <LinkContainer to={`${match.url}/admin/seasons`}>
                                        <Nav.Link>Seasons</Nav.Link>
                                    </LinkContainer>
                                    {/* <LinkContainer to={`${match.url}/admin/export-csv`}>
                                        <Nav.Link>Export CSV</Nav.Link>
                                    </LinkContainer> */}
                                    {/* </Nav> */}
                                </div>
                                :
                                null}
                        </Nav>
                    </Navbar>

                    <div className="pennant-routes">
                        <Switch>
                            <Route exact path={`${match.url}`}>
                                <PennantOverview />
                            </Route>
                            <Route path={`${match.url}/seasons`}>
                                <Seasons />
                            </Route>

                            {/* Admin Routes*/}
                            <Route path={`${match.url}/admin/players`}>
                                <Players />
                            </Route>
                            <Route path={`${match.url}/admin/seasons`}>
                                <AdminSeasons />
                            </Route>

                            <Route path={`${match.url}/admin/export-csv`}>
                                <ExportCSV />
                            </Route>


                        </Switch>
                    </div>
                </div>
            </Router>
        </div>
    )
}

